import {useEffect} from "react";

// https://www.youtube.com/watch?v=fVGgOCFzaqQ

const TrackMetaEvent = (
    event
) => {
    useEffect(() => {
        if (typeof window !== "undefined") {
            if (typeof window.fbq !== "undefined") {
                console.log("META event:", event);
                // Send META Event
                window.fbq('track', event);
            }
        }
    }, []);
};

// export const comprarEvent = () => {
//     fbq('track', 'Comprar');
// }

export {TrackMetaEvent};

